import { theme } from '@chakra-ui/theme';

export const FORM_PARTS = theme.components.Form.parts;
